import { Service } from '@/tools'
export class BroadcastService<T extends TOrder.BroadcastConfig> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.BroadcastConfig}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  private postUpload<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.BroadcastConfig}`, data?: TCommon.Json, toast?: string) {
    return this.post(
      {
        url: url,
        headers: {
          'Content-type': 'multipart/form-data',
        },
        method: 'post',
        data: data,
      },
      data,
      toast
    )
  }

  /**
   * 功能：发退广播列表
   */
  page = (data: T['ApiPage']['req']): Promise<T['ApiPage']['res']> => this.post2('v1/ApiPage', data)
  /**
   * 功能：发退广播详情
   */
  detail = (data: T['ApiDetail']['req']): Promise<T['ApiDetail']['res']> => this.post2('v1/ApiDetail', data)
  /**
   * 功能：发退广播商品列表
   */
  productPage = (data: T['ApiProductPage']['req']): Promise<T['ApiProductPage']['res']> => this.post2('v1/ApiProductPage', data)
  /**
   * 功能：发退广播详情基层店列表
   */
  orgList = (data: T['ApiOrgList']['req']): Promise<T['ApiOrgList']['res']> => this.post2('v1/ApiOrgList', data)
  /**
   * 功能：发退广播详情基层店记录列表
   */
  selectOrgList = (data: T['ApiSelectOrgList']['req']): Promise<T['ApiSelectOrgList']['res']> => this.post2('v1/ApiSelectOrgList', data)
  /**
   * 功能：发退广播通知
   */
  notice = (data: T['ApiNotice']['req']): Promise<T['ApiNotice']['res']> => this.post2('v1/ApiNotice', data)
  /**
   * 功能：发退广播撤销通知
   */
  notNotice = (data: T['ApiNotNotice']['req']): Promise<T['ApiNotNotice']['res']> => this.post2('v1/ApiNotNotice', data)
  /**
   * 功能：发退广播作废
   */
  cancel = (data: T['ApiCancel']['req']): Promise<T['ApiCancel']['res']> => this.post2('v1/ApiCancel', data)
  /**
   * 功能：发退广播撤销审核
   */
  cancelCheck = (data: T['ApiCancelCheck']['req']): Promise<T['ApiCancelCheck']['res']> => this.post2('v1/ApiCancelCheck', data)
  /**
   * 功能：发退广播新增返回基层店预估可退货数量、发货数量等
   */
  selectOrgNum = (data: T['ApiSelectOrgNum']['req']): Promise<T['ApiSelectOrgNum']['res']> => this.post2('v1/ApiSelectOrgNum', data)
  /**
   * 功能：发退广播打印
   */
  print = (data: T['ApiPrint']['req']): Promise<T['ApiPrint']['res']> => this.post2('v1/ApiPrint', data)
  /**
   * 功能：发退广播新增
   */
  add = (data: T['ApiAdd']['req']): Promise<T['ApiAdd']['res']> => this.post2('v1/ApiAdd', data)
  /**
   * 功能：发退广播编辑
   */
  update = (data: T['ApiUpdate']['req']): Promise<T['ApiUpdate']['res']> => this.post2('v1/ApiUpdate', data)
  /**
   * 功能：发退广播下发记录
   */
  selectIssueLogList = (data: T['ApiSelectIssueLogList']['req']): Promise<T['ApiSelectIssueLogList']['res']> =>
    this.post2('v1/ApiSelectIssueLogList', data)
  /**
   * 功能：发退广播再次通知
   */
  againBroadcast = (data: T['ApiAgainBroadcast']['req']): Promise<T['ApiAgainBroadcast']['res']> => this.post2('v1/ApiAgainBroadcast', data)
  /**
   * 功能：发退广播导入商品
   */
  importCommodity = (data: T['ApiImportCommodity']['req']): Promise<T['ApiImportCommodity']['res']> => this.postUpload('v1/ApiImportCommodity', data)
}
